// Swedish. Same keys as nb in ../i18n.ts (the type checks that).
import type { Key, Text } from '../i18n.ts';

export const sv: Record<Key, Text> = {
  appName: 'Hitta tid',
  tagline: 'hitta dagen som passar flest',
  privacy: 'Integritet',
  sourceCode: 'Källkod',
  heroTitle: 'Hitta tiden som passar flest',
  heroLead: 'Skapa en träff, välj möjliga dagar eller klockslag och dela länken. Alla markerar när de kan – utan inloggning.',
  newEvent: 'Ny träff',
  yourEvents: 'Dina träffar',
  yourEventsHint: 'Sparas bara på den här enheten. Länkarna fungerar på alla enheter.',
  showAllEvents: 'Visa alla ({n})',
  findLink: 'Hitta dina träffar från en annan enhet',
  findTitle: 'Hitta dina träffar',
  findLead: 'Skriv e-postadressen du angav när du skapade eller svarade på en träff. Vi skickar en kod till den, och sedan läggs träffarna till på den här enheten.',
  findEmail: 'E-postadress',
  findSend: 'Skicka kod',
  findSent: 'Om adressen har använts på en träff här kommer snart ett mejl med en kod. Koden gäller i 10 minuter.',
  findCode: 'Kod från mejlet',
  findShow: 'Visa mina träffar',
  findLinkLead: 'Tryck på knappen för att lägga till träffarna för din e-postadress på den här enheten. Länken fungerar en gång.',
  findAgain: 'Skicka ny kod',
  findOther: 'Använd en annan adress',
  findAsked: 'Bad om en ny kod.',
  findFound: { one: 'Hittade {n} träff. Den har lagts till på den här enheten.', other: 'Hittade {n} träffar. De har lagts till på den här enheten.' },
  findNone: 'Hittade inga träffar med den här adressen.',
  openAdmin: 'Admin',
  openMine: 'Mina svar',
  open: 'Öppna',
  tagAdmin: 'Admin',
  tagAnswered: 'Svarat',
  forget: 'Glöm på den här enheten',
  leave: 'Logga ut',
  leaveQ: 'Logga ut på den här enheten?',
  leaveTextAdmin: 'Admin-länken tas bort från den här enheten, och träffen försvinner från din lista här. Du behöver länken för att komma tillbaka, så spara den först.',
  leaveTextMine: 'Din personliga länk tas bort från den här enheten, och träffen försvinner från din lista här. Du behöver länken för att ändra dina svar senare, så spara den först.',
  leaveEmail: 'Du kan också få tillbaka länken med en kod till din e-postadress.',
  leftToast: 'Utloggad på den här enheten',
  step1: 'Välj möjliga dagar',
  step1Text: 'Datum, eller klockslag varje dag. Ta bort helger och helgdagar med ett tryck.',
  step2: 'Dela länken',
  step2Text: 'En länk till alla. Varje deltagare får en egen länk för att ändra sina svar.',
  step3: 'Se vad som passar',
  step3Text: 'Dagarna och tiderna som passar flest hamnar överst.',
  loading: 'Laddar …',
  pageNotFound: 'Sidan hittades inte',
  toHome: 'Till startsidan',
  eventNotFound: 'Träffen hittades inte',
  eventNotFoundText: 'Den kan ha tagits bort, eller så är länken fel. Träffar tas bort automatiskt 30 dagar efter sista datumet.',
  retry: 'Försök igen',
  reload: 'Ladda om',
  newVersion: 'En ny version är klar.',
  changedMeanwhile: 'Någon annan ändrade nyss träffen.',
  back: 'Tillbaka',
  cancel: 'Avbryt',
  ok: 'OK',
  done: 'Klar',
  save: 'Spara',
  saved: 'Sparat',
  delete: 'Ta bort',
  deleted: 'Borttaget',
  copy: 'Kopiera',
  copied: 'Kopierat',
  share: 'Dela',
  link: 'Länk',
  more: 'Mer',
  yes: 'Ja',
  maybe: 'Kanske',
  no: 'Nej',
  name: 'Namn',
  sum: 'Kan',
  you: 'du',
  language: 'Språk',

  editEvent: 'Ändra träffen',
  aboutEvent: 'Om träffen',
  eventName: 'Namn på träffen',
  eventNamePh: 'Till exempel ”Julbord”',
  descriptionOptional: 'Beskrivning (valfritt)',
  locationOptional: 'Plats (valfritt)',
  whatToFind: 'Vad ska ni hitta?',
  'mode.dates': 'Dagar',
  'mode.datesHint': 'Vilka dagar passar?',
  'mode.times': 'Klockslag',
  'mode.timesHint': 'Vilka tider passar, dag för dag?',
  fromHour: 'Från kl.',
  toHour: 'Till kl.',
  slotLength: 'Rutor på',
  meetingLength: 'Mötet varar',
  timeZone: 'Tidszon',
  timeZoneHint: 'Alla ser tiderna i den här tidszonen.',
  possibleDays: 'Möjliga dagar',
  theme: 'Tema',
  'theme.auto': 'Automatiskt',
  'theme.autoHint': 'Ljust eller mörkt, som enheten',
  'theme.light': 'Ljust',
  'theme.dark': 'Mörkt',
  'theme.hacker': 'Hacker',
  rangeHint: 'Dra från en dag till en annan för att ta med alla dagar emellan, eller klicka på den första och skift-klicka på den sista.',
  rangeHintTouch: 'Håll fingret på en dag och dra till en annan för att ta med alla dagar emellan.',
  possibleDaysHint: 'Tryck på dagarna som kan passa, eller välj flera med knapparna. Knapparna ändrar bara urvalet – du kan fortfarande lägga till eller ta bort enskilda dagar efteråt.',
  period2w: 'Nästa 2 veckor',
  period4w: 'Nästa 4 veckor',
  periodMonth: 'Hela {month}',
  periodHint: 'Väljer just de här dagarna (i stället för dem du har valt)',
  moreMonths: 'Visa nästa månad',
  selNone: 'Inga',
  undo: 'Ångra',
  redo: 'Gör om',
  removedDays: { one: 'Tog bort 1 dag', other: 'Tog bort {n} dagar' },
  timesCleared: 'Tiderna togs bort',
  weekdays: 'Vardagar',
  weekends: 'Helger',
  holidays: 'Helgdagar',
  weekdaysHint: 'Ta bort de valda vardagarna (måndag–fredag), eller välj alla i kalendern',
  weekendsHint: 'Ta bort de valda lördagarna och söndagarna, eller välj alla i kalendern',
  holidaysHint: 'Ta bort de valda helgdagarna, eller välj alla helgdagar i kalendern',
  weekdayHint: 'Ta bort de valda {day}arna, eller välj alla i kalendern',
  toggleWeek: 'Välj eller ta bort vecka {n}',
  weekShort: 'V',
  nDays: { one: '1 dag vald', other: '{n} dagar valda' },
  nSlots: { one: '1 tidsruta', other: '{n} tidsrutor' },
  nDaysNoTimes: { one: '1 dag utan tider', other: '{n} dagar utan tider' },
  possibleTimes: 'Möjliga tider',
  possibleTimesHint: 'Dra över rutorna för att markera eller ta bort tider. Tryck på en dag överst för fler val.',
  possibleTimesHintTouch: 'Tryck på en ruta för att markera eller ta bort den, eller håll fingret på en ruta och dra över flera. Tryck på en dag överst för fler val.',
  'preset.all': 'Hela dagen',
  'preset.work': 'Arbetstid 9–17',
  'preset.evening': 'Kväll 17–22',
  'preset.clear': 'Inga tider',
  pickDaysFirst: 'Välj dagar i kalendern först.',
  dayAll: 'Välj hela dagen',
  dayClear: 'Ta bort alla tider den här dagen',
  dayCopy: 'Använd de här tiderna alla dagar',
  dayCopyHint: 'Dagar du lägger till senare får också de här tiderna',
  dayRemove: 'Ta bort dagen',
  settings: 'Inställningar',
  'set.maybe': 'Tillåt ”kanske”',
  'set.maybeHint': 'Deltagarna kan svara ”kan om det behövs”.',
  'set.maybeCounts': '”Kanske” räknas som att de kan',
  'set.maybeCountsHint': 'Rangordningen räknar alla som kan eller kanske kan. Annars räknas bara ja, och vid lika många ja kommer den med flest ”kanske” först.',
  'set.openEdit': 'ändra och ta bort allas svar',
  'set.openEditHint': 'Annars bara sitt eget.',
  'set.hidden': 'se svaren',
  'set.hiddenHint': 'Vem som har svarat vad, och hur många. Annars ser bara arrangörerna det, och varje deltagare sitt eget svar.',
  'set.closed': 'Stängd för nya svar',
  'set.closedHint': 'Ingen utom arrangörerna kan svara eller ändra något.',
  'set.newNames': 'svara under ett nytt namn',
  'set.newNamesHint': 'Annars kan bara namnen ni har lagt på listan svara.',
  'set.claims': 'svara som ett namn på listan',
  'set.claimsHint': 'Genom att trycka på sitt namn med länken till träffen. Annars behöver de sin personliga länk från er.',
  'set.rename': 'ändra sitt namn',
  'set.renameHint': 'Annars står namnet som det skrevs först, eller som ni skrev det på listan.',
  'set.decide': 'välja vad det blir',
  'set.decideHint': 'Välja den slutliga dagen eller tiden, och ångra valet. Träffen förblir öppen: bara arrangörerna stänger den.',
  'set.details': 'ändra namn, plats och beskrivning',
  'set.detailsHint': 'På träffen. Det syns inte vem som ändrade dem, men ni kan alltid ändra tillbaka.',
  yourEmailOptional: 'Din e-post (valfritt)',
  adminEmailsOptional: 'Arrangörernas e-post (valfritt)',
  addDetails: 'Lägg till beskrivning och plats',
  manyWeeks: 'Deltagarna måste gå igenom {n} veckor med tider, en vecka i taget på mobilen. Färre dagar gör det snabbare att svara.',
  emailOptional: 'E-post (valfritt)',
  addEmail: 'Lägg till e-post',
  adminEmailHint: 'Sparas med träffen, så att du kan hitta träffen igen på en annan enhet (vi mejlar dig en kod). Är ni flera arrangörer kan ni lägga in en e-post var. Bara de med admin-länken ser dem.',
  addEmailRow: 'Lägg till en e-post till',
  removeEmail: 'Ta bort e-postadressen',
  createEvent: 'Skapa träff',
  saveChanges: 'Spara ändringar',
  lostAnswers: {
    one: '1 svar gäller dagar eller tider som tas bort, och raderas.',
    other: '{n} svar gäller dagar eller tider som tas bort, och raderas.',
  },
  saveAnyway: 'Spara ändå',

  createdTitle: 'Träffen är klar!',
  createdText: 'Dela länken till träffen med dem du vill bjuda in. Spara admin-länken: med den ändrar du träffen, och du kan dela den med andra arrangörer.',
  savedNewTitle: 'Tack, {name}! Svaren är sparade.',
  savedNewText: 'Det här är din personliga länk. Med den kan du ändra svaren senare, från vilken enhet som helst.',
  savedNewHint: 'Spara länken: lägg till den som bokmärke eller skicka den till dig själv. Dela den inte – den som har länken kan ändra dina svar.',
  yourLink: 'Din personliga länk',
  linkInvalid: 'Den här länken fungerar inte längre. Den kan ha bytts ut mot en ny, eller så har svaret tagits bort. Du ser träffen som gäst.',
  storedAdmin: 'Du är admin för den här träffen på den här enheten.',
  storedMine: 'Den här enheten har din personliga länk till den här träffen.',
  closedInfo: 'Träffen är stängd för nya svar.',
  closedAdmin: 'Träffen är stängd. Bara arrangörerna kan lägga till eller ändra svar.',
  metaDates: { one: '1 möjlig dag', other: '{n} möjliga dagar' },
  metaTimes: 'Klockslag · mötet varar {dur}',
  timesIn: 'Tider i {tz}',
  yourTz: '(du är i {tz})',
  metaHidden: 'Bara arrangörerna ser svaren',
  metaOpenEdit: 'Alla kan ändra svaren',
  permsTitle: 'Deltagarna kan',
  metaListOnly: 'Bara namnen på listan kan svara',
  metaDecide: 'Alla kan välja vad det blir',
  editDetails: 'Ändra namn och plats',
  editDetailsHint: 'Alla med länken till träffen ser ändringen.',
  detailsSaved: 'Ändringarna är sparade.',
  listOnlyInfo: 'Bara de på listan kan svara, med den personliga länk de har fått av arrangörerna.',
  listOnlyClaim: 'Bara namnen på listan kan svara.',
  nameFixed: 'Namnet kan inte ändras på den här träffen.',
  youAreAdmin: 'Du är admin',
  adminHint: 'Du kan ändra träffen och alla svar.',
  addAnswers: 'Lägg till svar',
  personName: 'Namn',
  close: 'Stäng',
  reopen: 'Öppna igen',
  hiName: 'Hej, {name}!',
  personalHint: 'Det här är din personliga länk. Använd den när du vill ändra svaren.',
  editYourAnswers: 'Ändra dina svar',
  copyMyLink: 'Kopiera min länk',
  shareEvent: 'Dela träffen',
  addYourAnswers: 'Lägg till dina svar',
  shareTitle: 'Dela träffen',
  shareHint: 'Skicka den här länken till alla som ska vara med.',
  eventLink: 'Länk till träffen',
  adminLinkTitle: 'Admin-länken',
  adminLinkHint: 'Dela den med dem som ska vara arrangörer tillsammans med dig. Alla som har den kan ändra träffen och alla svar.',
  qrTitle: 'QR-kod för träffen',
  resultsTitle: 'Vad passar bäst?',
  noAnswersYet: 'Ingen har svarat än.',
  noneAvailable: 'Inget av alternativen passar någon än.',
  hiddenInfo: 'Svaren är dolda: bara arrangörerna ser dem och hur många som har svarat.',
  'tab.cal': 'Kalender',
  'tab.list': 'Lista',
  'tab.table': 'Tabell',
  'tab.grid': 'Rutnät',
  legendFew: 'Få kan',
  legendMany: 'Många kan',
  legendTop: 'Flest kan',
  tapForDetails: 'Tryck på ett alternativ för att se vem som kan.',
  tapCellForDetails: 'Tryck på en ruta för att se vem som kan.',
  nOfM: '{n} av {m} kan',
  decidedTitle: 'Bestämt',
  decidedTag: 'Vald',
  decidedThis: 'Det här är valt',
  decideThis: 'Välj {when}',
  decideQ: 'Välja {when}? Alla som öppnar träffen ser valet, och träffen stängs för nya svar.',
  decideOk: 'Välj',
  decidedToast: 'Valt. Dela länken, så ser alla det.',
  undecideQ: 'Ångra valet? Träffen förblir stängd tills du öppnar den igen.',
  decideQOpen: 'Välja {when}? Alla som öppnar träffen ser valet.',
  undecideQOpen: 'Ångra valet?',
  undoDecision: 'Ångra valet',
  undecidedToast: 'Valet är ångrat',
  addToCalendar: 'Lägg till i kalendern',
  nMaybe: { one: '1 kanske', other: '{n} kanske' },
  nMaybeIncl: { one: 'inkl. 1 kanske', other: 'inkl. {n} kanske' },
  moreTied: { one: 'Visa 1 till med lika många som kan', other: 'Visa {n} till med lika många som kan' },
  showFewer: 'Visa färre',
  rankYesFirst: 'Rangordnat efter flest ja. Vid lika många kommer den med flest ”kanske” först.',
  rankMaybeCounts: 'Rangordnat efter flest som kan, ”kanske” medräknat. Vid lika många kommer den med flest ja först.',
  canCome: 'Kan',
  ifNeedBe: 'Kanske',
  cannot: 'Kan inte',
  responses: 'Svar',
  hiddenPeople: 'Svaren är dolda. Du ser bara ditt eget.',
  sumYes: 'Kan {n} av {m}',
  sumYesTime: 'Kan {dur}',
  maybeDur: 'kanske {dur}',
  sumNoneDates: 'Kan ingen av dagarna',
  sumNoneTimes: 'Kan ingen av tiderna',
  nOfTotal: '{n} av {m}',
  answeredOf: '{n} av {m} har svarat',
  notAnswered: 'Har inte svarat än',
  noAnswer: 'Ej svarat',
  youNotAnswered: 'Du har inte svarat än.',
  addNames: 'Lägg till namn',
  addNamesTitle: 'Vilka är inbjudna?',
  addNamesText: 'Ett namn per rad, eller klistra in en lista. Då ser du vilka som inte har svarat än, och var och en får en egen länk som du kan skicka till dem. Namnen visas för alla som öppnar träffen, om inte svaren är dolda.',
  addNamesPh: 'Anna\nErik\nMaja',
  addNamesOk: 'Lägg till',
  namesAdded: { one: 'Lade till 1 namn.', other: 'Lade till {n} namn.' },
  namesSkipped: { one: '1 namn fanns redan.', other: '{n} namn fanns redan.' },
  copyReminder: 'Kopiera påminnelse',
  reminderText: '{names}: glöm inte att svara på ”{name}”! {url}',
  claimQ: 'Är du en av dessa?',
  claimHint: 'Tryck på ditt namn så sparas dina svar där. Står du inte på listan skriver du bara ditt namn.',
  claimWho: 'Vem är du?',
  claimListHint: 'Bara namnen på listan kan svara. Skriv för att hitta ditt.',
  claimAdmin: 'Svarar du för någon av dessa?',
  claimAdminHint: 'Tryck på ett namn för att lägga svaren där, eller skriv ett nytt namn.',
  answerFor: 'Svara för {name}',
  removeName: 'Ta bort {name}',
  removeNameQ: 'Ta bort {name} från listan?',
  remove: 'Ta bort',
  showAnswered: 'Visa som besvarat',
  draftNoteOwn: 'Sparas som utkast: du står under ”Har inte svarat än”, och svaren räknas inte förrän du sparar med den här ikryssad.',
  draftNote: 'Sparas som utkast: personen står under ”Har inte svarat än”, och svaren räknas inte förrän de sparas med den här ikryssad.',
  draftSaved: 'Utkastet är sparat. Det räknas inte förrän det sparas som besvarat.',
  savedDraftTitle: 'Ditt utkast är sparat, {name}.',
  youHaveDraft: 'Du har ett utkast som inte räknas än.',
  claimNone: 'Ingen på listan heter så, så det blir ett nytt namn.',
  claimMatches: { one: '1 namn på listan passar', other: '{n} namn på listan passar' },
  showAllNames: 'Visa alla ({n})',
  answerAs: 'Svara som {name}',
  copyPersonLink: 'Länken till {name}',
  deleteEntry: 'Ta bort svaret från {name}',
  expiresNote: 'Träffen tas bort automatiskt {date}.',
  adminMenu: 'Admin',
  newAdminLink: 'Ny admin-länk',
  newAdminLinkHint: 'Den gamla slutar fungera',
  newAdminLinkQ: 'Skapa en ny admin-länk? Den gamla slutar fungera direkt, för alla som har den.',
  makeNewLink: 'Skapa ny länk',
  newLinkDone: 'Ny länk',
  newAdminLinkDoneText: 'Det här är den nya admin-länken. Den gamla fungerar inte längre, så skicka den här till eventuella andra arrangörer.',
  deleteEvent: 'Ta bort träffen',
  deleteEventHint: 'Tar bort allt, även alla svar',
  deleteEventQ: 'Ta bort träffen och alla svar? Det går inte att ångra.',
  eventDeleted: 'Träffen är borttagen',
  meMenu: 'Dina svar',
  newMyLink: 'Ny personlig länk',
  newMyLinkHint: 'Den gamla slutar fungera',
  newMyLinkQ: 'Skapa en ny personlig länk? Den gamla slutar fungera direkt.',
  newMyLinkDoneText: 'Det här är din nya personliga länk. Den gamla fungerar inte längre.',
  deleteMine: 'Ta bort mina svar',
  deleteMineQ: 'Ta bort dina svar?',
  deleteEntryQ: 'Ta bort svaret från {name}?',
  personLinkTitle: 'Länken till {name}',
  personLinkText: 'Den som har den här länken kan ändra svaren. Skicka den bara till personen det gäller.',
  addedByAdminText: 'Svaret är tillagt. Med den här länken kan personen själv ändra svaren senare.',
  closedToast: 'Träffen är stängd',
  reopenedToast: 'Träffen är öppnad igen',

  editAnswersOf: 'Ändra svaren från {name}',
  yourName: 'Ditt namn',
  emailHint: 'Sparas med svaret, så att du kan hitta träffen igen på en annan enhet (vi mejlar dig en kod). Ingen annan ser den.',
  commentOptional: 'Kommentar (valfritt)',
  commentPh: 'Till exempel ”Kan bara efter kl. 18”',
  whichDays: 'Vilka dagar passar?',
  whichTimes: 'Vilka tider passar?',
  answerDatesHint: 'Tryck på dagarna du kan.',
  answerDatesHintMaybe: 'Tryck en gång för ”ja”, två gånger för ”kanske” och tre gånger för att ta bort.',
  answerTimesHint: 'Dra över tiderna du kan. Dra från en markerad ruta för att ta bort. Tryck på en dag överst för att svara för hela dagen.',
  answerTimesHintMaybe: 'Välj ”Kan” eller ”Kanske” och dra över tiderna. Dra från en markerad ruta för att ta bort. Tryck på en dag överst för att svara för hela dagen.',
  answerTimesHintTouch: 'Tryck på tiderna du kan, eller håll fingret på en ruta och dra över flera. Börja på en markerad ruta för att ta bort. Tryck på en dag överst för att svara för hela dagen.',
  answerTimesHintTouchMaybe: 'Välj ”Kan” eller ”Kanske” och tryck på tiderna, eller håll fingret på en ruta och dra över flera. Börja på en markerad ruta för att ta bort. Tryck på en dag överst för att svara för hela dagen.',
  brush: 'Markera som',
  yesToAll: 'Ja till alla',
  clearAll: 'Nollställ',
  dayYes: 'Kan hela dagen',
  dayMaybe: 'Kanske hela dagen',
  dayNone: 'Kan inte den här dagen',
  pickSumDates: 'Du kan {n} av {m} dagar',
  pickSumTimes: 'Du kan {dur}',
  pickSumNone: 'Inget markerat än',
  discardQ: 'Kasta ändringarna?',
  discard: 'Kasta',

  weeks: 'Veckor',
  weekN: 'Vecka {n}',
  weekRange: 'Vecka {a}–{b}',
  weekPair: 'Vecka {a} och {b}',
  gridPaintLabel: 'Tider. Piltangenterna flyttar, mellanslag markerar.',
  gridViewLabel: 'Översikt över tiderna',

  'err.network': 'Fick ingen kontakt med servern. Kontrollera nätet och försök igen.',
  'err.rate': 'För många förfrågningar. Vänta en stund och försök igen.',
  'err.notFound': 'Träffen hittades inte.',
  'err.forbidden': 'Du har inte behörighet att göra det här.',
  'err.listOnly': 'Bara namnen på listan kan svara. Välj ditt.',
  'err.rename': 'Namnet kan inte ändras på den här träffen.',
  'err.decided': 'Det är inte ett av alternativen.',
  'err.closed': 'Träffen är stängd för nya svar.',
  'err.full': 'Träffen har fått så många svar som den kan ta emot.',
  'err.person': 'Svaret hittades inte. Det kan ha tagits bort.',
  'err.personName': 'Skriv ditt namn.',
  'err.email': 'E-postadressen ser inte rätt ut.',
  'err.emails': 'Högst 10 e-postadresser.',
  'err.code': 'Koden är fel eller har gått ut.',
  'err.link': 'Länken har redan använts eller har gått ut. Be om en ny kod.',
  'err.wait.minute': 'Du bad nyss om en kod. Vänta en minut innan du ber om en ny.',
  'err.wait.hour': 'Du har bett om flera koder. Försök igen om en timme.',
  'err.wait.day': 'Dagens gräns för koder är nådd. Försök igen i morgon.',
  'err.mail': 'Vi kan inte skicka e-post just nu. Försök igen senare.',
  'err.name': 'Ge träffen ett namn.',
  'err.range': 'Ogiltiga datum.',
  'err.rangeLong': 'Det kan vara högst ett år från första till sista dagen.',
  'err.rangeLongTimes': 'Med klockslag kan det vara högst 62 dagar från första till sista dagen.',
  'err.hours': 'Välj ett giltigt tidsintervall.',
  'err.options': 'Välj minst en möjlig dag eller tid.',
  'err.tooMany': 'För många möjliga tider (högst 2000). Välj färre dagar eller längre rutor.',
  'err.server': 'Något gick fel. Försök igen.',
  'err.taken': 'Någon har precis svarat med det namnet. Välj ett annat, eller skriv ditt namn.',
  'err.answered': 'Personen har precis svarat själv, så deras svar finns kvar.',
  'err.names': 'Skriv minst ett namn.',
  'err.tooManyNames': 'Det blir för många. En träff kan ha högst 200 namn och svar sammanlagt.',

  'holiday.newYear': 'Nyårsdagen',
  'holiday.maundyThursday': 'Skärtorsdagen',
  'holiday.goodFriday': 'Långfredagen',
  'holiday.easter': 'Påskdagen',
  'holiday.easterMonday': 'Annandag påsk',
  'holiday.mayDay': 'Första maj',
  'holiday.constitutionDay': 'Norges nationaldag',
  'holiday.ascension': 'Kristi himmelsfärdsdag',
  'holiday.whitsun': 'Pingstdagen',
  'holiday.whitMonday': 'Annandag pingst',
  'holiday.christmas': 'Juldagen',
  'holiday.boxingDay': 'Annandag jul',
  'holiday.christmasEve': 'Julafton',
  'holiday.newYearsEve': 'Nyårsafton',
  'holiday.epiphany': 'Trettondedag jul',
  'holiday.nationalDaySe': 'Sveriges nationaldag',
  'holiday.midsummerEve': 'Midsommarafton',
  'holiday.midsummerDay': 'Midsommardagen',
  'holiday.allSaints': 'Alla helgons dag',
  'holiday.greatPrayerDay': 'Stora böndagen',
  holidayCal: 'Helgdagar i kalendern',
  holidayCalHint: 'Helgdagarna får en prick, och knappen ”Helgdagar” väljer dem. Julafton och nyårsafton är med, i Sverige även midsommarafton.',
  'holidayCal.no': 'Norge',
  'holidayCal.se': 'Sverige',
  'holidayCal.dk': 'Danmark',
  'holidayCal.none': 'Inga',
};
